import {
  type CreateOrderData,
  type AmountBreakdown,
  type OrderItem as OrderItemPayPal,
} from '@wix/cashier-core/dist/src/services/PayPal/types';
import { type PaymentBreakdown } from '../../types/PaymentBreakdown';
import { type ShippingContact } from '../../types/Shipping';
import { type PayPalShippingAddress } from '../../types/paypal';
import { type OrderItem } from '../../types/OrderItem';

export interface OrderData {
  paymentAmount: string;
  paymentBreakdown: PaymentBreakdown;
  orderItems: OrderItem[];
  currencyCode: string;
  requestShipping: boolean;
}

/**
 * Transforms data to backend-compatible structure
 * @param data
 */
export function transformOrderDataToPayPal(data: OrderData): CreateOrderData {
  return {
    totalAmount: Number(data.paymentAmount),
    currency: data.currencyCode,
    amountBreakdown: transformPaymentBreakdownToPayPal(data.paymentBreakdown),
    orderItems: transformOrderItemsToPayPal(data.orderItems),
    requestShipping: data.requestShipping,
  };
}

export function transformPaymentBreakdownToPayPal(paymentBreakdown: PaymentBreakdown): AmountBreakdown {
  if (!paymentBreakdown) {
    return null;
  }

  return Object.entries(paymentBreakdown).reduce<Partial<AmountBreakdown>>((acc, [key, value]) => {
    acc[key] = Number(value);
    return acc;
  }, {}) as AmountBreakdown;
}

export function transformOrderItemsToPayPal(orderItems: OrderItem[] = []): OrderItemPayPal[] {
  return orderItems.map((item) => ({
    ...item,
    price: Number(item.price),
    // https://wix.atlassian.net/browse/PAY-1652
    category: undefined,
  }));
}

export const transformToShippingContact = (data: PayPalShippingAddress): ShippingContact => {
  return {
    countryCode: data.country_code,
    city: data.city,
    postalCode: data.postal_code,
    state: data.state,
  };
};
